module.exports = __webpack_public_path__ + "static/media/13.Foreign Tour.8b07dd20.JPG";